export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_JP_RGB_blk_100317.621b45d8.svg";